import React from 'react';
import 'flag-icons/css/flag-icons.min.css';
import './FlagIcon.css';

interface FlagIconProps {
  isoCode: string;
}

/**
 * FlagIcon component displays a country flag using flag-icons library
 * This ensures consistent flag rendering across all platforms, including Windows
 *
 * @param isoCode - flag-icons country or subdivision code (typically lowercase ISO 3166-1 alpha-2, e.g., 'fi', 'se', 'us', 'gb-eng')
 */
export const FlagIcon: React.FC<FlagIconProps> = ({ isoCode }) => {
  if (!isoCode) {
    return <span className='fi result-flag-icon flag-no-country' />;
  }

  return <span className={`fi fi-${isoCode} result-flag-icon`} />;
};
